/** Reorders items by id list; unknown ids keep their relative order at the end. */
export const orderByIds = <T extends { id: string }>(
  items: readonly T[],
  order?: readonly string[],
): T[] => {
  if (!order?.length) return [...items];

  const byId = new Map(items.map((item) => [item.id, item]));
  const ordered: T[] = [];

  for (const id of order) {
    const item = byId.get(id);
    if (!item) continue;
    ordered.push(item);
    byId.delete(id);
  }

  ordered.push(...byId.values());
  return ordered;
};
